<template>
  <nav class="navbar navbar-expand-lg fixed-top bg-secondary">
    <div class="container-fluid">

      <button class="navbar-toggler" type="button" @click="toggleNavbar" :aria-expanded="isOpen"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" :class="{ show: isOpen }" ref="navbarCollapse">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-2">
          <li class="nav-item">
            <router-link class="nav-link" to="/dashboard" @click="closeNavbar">
              {{ $t("navbar.dashboard") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_order')">
            <router-link class="nav-link" to="/orders" @click="closeNavbar">
              {{ $t("navbar.orders") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_transportation')">
            <router-link class="nav-link" to="/transportations" @click="closeNavbar">
              {{ $t("navbar.transportations") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_customer')">
            <router-link class="nav-link" to="/customers" @click="closeNavbar">
              {{ $t("navbar.customers") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_calculation')">
            <router-link class="nav-link" to="/calculations" @click="closeNavbar">
              {{ $t("navbar.calculations") }}
            </router-link>
          </li>

          <!-- Dropdown Vacations -->
          <li class="nav-item dropdown"
            v-if="$store.getters.hasPerm('view_vacationuser') || $store.getters.hasPerm('view_vacationwarehouse')"
            @mouseenter="isDesktop && openDropdown()" @mouseleave="isDesktop && closeDropdown()">
            <a class="nav-link dropdown-toggle" href="#" role="button" @click.prevent="toggleDropdown"
              :aria-expanded="dropdownOpen">
              {{ $t("navbar.vacations") }}
            </a>
            <ul class="dropdown-menu" :class="{ show: dropdownOpen }">
              <li v-if="$store.getters.hasPerm('view_vacationwarehouse')">
                <router-link class="dropdown-item" to="/warehouse-vacations" @click="closeNavbar; closeDropdown">
                  {{ $t("navbar.warehouseVacations") }}
                </router-link>
              </li>
              <li v-if="$store.getters.hasPerm('view_vacationuser')">
                <router-link class="dropdown-item" to="/user-vacations" @click="closeNavbar; closeDropdown">
                  {{ $t("navbar.userVacations") }}
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_warehouse')">
            <router-link class="nav-link" to="/warehouses" @click="closeNavbar">
              {{ $t("navbar.warehouses") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_product')">
            <router-link class="nav-link" to="/products" @click="closeNavbar">
              {{ $t("navbar.products") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_stats')">
            <router-link class="nav-link" to="/overviews" @click="closeNavbar">
              {{ $t("navbar.overviews") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_productconversion')">
            <router-link class="nav-link" to="/product-conversions" @click="closeNavbar">
              {{ $t("navbar.productConversions") }}
            </router-link>
          </li>

          <li class="nav-item" v-if="$store.getters.hasPerm('view_user')">
            <router-link class="nav-link" to="/users" @click="closeNavbar">
              {{ $t("navbar.users") }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/account" @click="closeNavbar">
              {{ $t("navbar.myProfile") }}
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/logout" @click="closeNavbar">
              {{ $t("navbar.logout") }}
            </router-link>
          </li>

          <!-- Language switcher -->
          <li class="nav-item d-flex align-items-center">
            <ChangeLang class="mx-2 my-1" />
          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import ChangeLang from "@/components/ChangeLang.vue"

export default {
  components: { ChangeLang },
  data() {
    return {
      isOpen: false, // collapse hamburger menu
      dropdownOpen: false, // vacations dropdown
    }
  },
  computed: {
    isDesktop() {
      return window.innerWidth >= 992 // breakpoint lg
    }
  },
  methods: {
    toggleNavbar() {
      this.isOpen = !this.isOpen
    },
    closeNavbar() {
      this.isOpen = false
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    openDropdown() {
      this.dropdownOpen = true
    },
    closeDropdown() {
      this.dropdownOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
.navbar-brand {
  font-weight: 600;
  font-size: 1.5rem;
  text-transform: uppercase;
}

.nav-link {
  font-weight: 500;
  font-size: 1.2rem;
}

.cursor-pointer {
  cursor: pointer;
}

.dropdown-menu {
  min-width: 180px;
}
</style>
